import { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../App";
import ReactMarkdown from "react-markdown";
import "../styles/RunningBanner.css";

export default function RunningBanner() {
  const [banner, setBanner] = useState({ enabled: false, text: "", speed: 30, spacing: 100 });

  useEffect(() => {
    loadBanner();
    
    // Reload banner every 30 seconds
    const intervalId = setInterval(loadBanner, 30000);
    return () => clearInterval(intervalId);
  }, []);

  const loadBanner = async () => {
    try {
      const res = await axios.get(`${API}/banner`);
      setBanner(res.data);
    } catch (err) {
      console.error("Error loading banner:", err);
    }
  };

  if (!banner.enabled || !banner.text) {
    return null;
  }

  const speed = banner.speed || 30;
  const spacing = banner.spacing || 100;

  const renderContent = () => (
    <ReactMarkdown
      components={{
        p: ({node, ...props}) => <span {...props} />,
        strong: ({node, ...props}) => <strong style={{ fontWeight: 'bold' }} {...props} />,
        em: ({node, ...props}) => <em style={{ fontStyle: 'italic' }} {...props} />,
        a: ({node, ...props}) => <a style={{ textDecoration: 'underline' }} {...props} />
      }}
    >
      {banner.text}
    </ReactMarkdown>
  );

  // Render multiple copies to ensure seamless loop
  const copies = Array(5).fill(null);

  return (
    <div className="running-banner-container">
      <div 
        className="running-banner-track"
        style={{
          animationDuration: `${speed}s`
        }}
      >
        {copies.map((_, index) => (
          <span key={index} className="running-banner-content" style={{ marginRight: `${spacing}px` }}>
            {renderContent()}
          </span>
        ))}
      </div>
    </div>
  );
}
